import React from 'react'
import SmartFilterContext from './SmartFilterContext'

export default function useSmartFilter () {
    return React.useContext(SmartFilterContext)
}